import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import Logger from '../shared/helpers/logger';

export default class BrickLayer {
  static queue(name, ...args) {
    if (name === 'build') {
      BrickLayer.build(...args);
    } else {
      Logger.error(`Unrecongnized action ${name}`);
    }
  }

  static build(el, parameters) {
    ReactDOM.render(<App queryParams={parameters} />, el);
  }
}



// WEBPACK FOOTER //
// ./src/client/brick-layer.jsx